import { gql } from '@apollo/client';
import { AvailabilityType } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { ReimbursedProduct } from '@queries/userInsurance/queries/getInsuranceQuote';

export const PayOrderFintoc = () => gql`
  mutation PayOrderFintoc($params: PayOrderFintocParams!) {
    payOrderFintoc(params: $params) {
      fintocToken
      uuid
      orderGroupId
    }
  }
`;

export interface PayOrderFintocDetails {
  productId: number;
  price: number;
  quantity: number;
  availability: AvailabilityType;
}
export interface PayOrderFintocInfo {
  deliveryDate: string;
  details: PayOrderFintocDetails[];
  reimbursedProductsInfo: ReimbursedProduct[];
}

export type PayOrderFintocMutationParams = ResolverParams<{
  orderUuid: string;
  orders: PayOrderFintocInfo[];
  amount: number;
  useCredits: boolean;
  insuranceId: number;
}>;

export type PayOrderFintocMutationResponse = {
  payOrderFintoc: {
    fintocToken: string;
    uuid: string;
    orderGroupId: string;
  };
};
